import React, { useState } from 'react';
import JsonNavigator from '../../jsonnavigator/JsonNavigator.js';
import sampleJson from '../sampleJson.js';

const Sports = () => {

    return <JsonNavigator data={sampleJson}></JsonNavigator>
}



export default Sports